import { Reducer, Action } from "redux";

import { UserActionTypes } from "./user.types";
import { User } from "../../models";

const INITIAL_STATE: User = {
  isLogged: false,
  idleModal: false,
  ipAddress: "",
  authData: {
    access_token: "",
    access_token_expiry: 0,
    refresh_token: "",
    refresh_token_expiry: 0,
    id_token: "",
    id_token_expiry: 0,
  },
  userData: {
    iat: 0,
    nbf: 0,
    jti: "",
    exp: 0,
    is_first_time_login: false,
    role_id: 0,
    name: "",
    user_territories: [],
    active_territories: {},
    location_access: [],
    non_location_access: [],
    account_group: "",
    user_id: 0,
    tour: false,
  },
  userDetails: {
    contact_number: 0,
    email: "",
    name_firm: "",
    name: "",
    user_name: "",
    address: "",
    location: "",
    state: "",
    postal_code: 0,
    vendor_code: 0,
    role_id: 0,
    role_name: "",
    profile_photo: "",
    user_id: 0,
  },
};

const userReducer: Reducer<User, Action> = (
  state = INITIAL_STATE,
  action: any
) => {
  switch (action.type) {
    case UserActionTypes.SET_LOGGED_IN_STATUS:
      return {
        ...state,
        isLogged: action.payload,
      };
    case UserActionTypes.SET_AUTH_DATA:
      return {
        ...state,
        authData: action.payload,
      };
    case UserActionTypes.SET_USER_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload,
        },
      };
    case UserActionTypes.SET_IDLE_MODAL:
      return {
        ...state,
        idleModal: action.payload,
      };
    case UserActionTypes.SET_IP_ADDRESS:
      return {
        ...state,
        ipAddress: action.payload,
      };
    case UserActionTypes.SET_USER_DETAILS:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.payload,
        },
      };
    case UserActionTypes.SET_FIRST_LOGIN:
      return {
        ...state,
        userData: {
          ...state.userData,
          is_first_time_login: action.payload,
          tour: true,
        },
      };
    case UserActionTypes.SET_TOUR:
      return {
        ...state,
        userData: {
          ...state.userData,
          tour: action.payload,
        },
      };
    case UserActionTypes.RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default userReducer;
